import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ClassNames from 'classnames';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core';
import Mixpanel from 'utils/mixpanelService';
import useSiteCopySelector from 'components/useSiteCopySelector';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import useIsAuthPath from 'components/Hooks/useIsAuthPath';
import { isEmbedded } from 'utils/embedded';

const useStyles = makeStyles(() => ({
  inCrisisLink: {
    fontFamily: 'Mada !important',
    color: 'white !important',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    textTransform: 'uppercase !important',
    borderRadius: '10px',
    padding: '0px 7px',
    backgroundColor: '#AD0000',
  },
}));

const useInCrisis = ({ buttonClassName } = {}) => {
  const classes = useStyles();

  const [navBarMenuPageCopy] = useSiteCopySelector(['navbar-menu']);
  const clientDetails = useSelector(makeSelectClientDetails());
  const isAuthPath = useIsAuthPath();
  const isEmbed = isEmbedded();

  const inCrisisNoDisplay = _get(
    clientDetails,
    'metadata.inCrisisNoDisplay',
    false,
  );

  const showInCrisisInMainNavigation = _get(
    clientDetails,
    'metadata.inCrisisMainNavigation',
    false,
  );

  const showInCrisisInHeader = !(
    inCrisisNoDisplay ||
    showInCrisisInMainNavigation ||
    isEmbed
  );

  const renderInCrisisButton = useCallback(() => {
    if (isAuthPath || !showInCrisisInHeader) return null;

    return (
      <Link
        to={{ pathname: '/in-crisis', state: { section: 'header' } }}
        className={ClassNames(classes.inCrisisLink, buttonClassName)}
        onClick={() => {
          Mixpanel.track('In Crisis Button - Clicked', {
            path: window.location.pathname,
          });
        }}
      >
        {_get(navBarMenuPageCopy, ['pageCopy', 'header-menu', 'in-crisis'], '')}
      </Link>
    );
  }, [
    showInCrisisInHeader,
    buttonClassName,
    classes.inCrisisLink,
    navBarMenuPageCopy,
    isAuthPath,
  ]);

  return {
    renderInCrisisButton,
    showInCrisisInHeader,
    inCrisisNoDisplay,
    showInCrisisInMainNavigation,
  };
};

export default useInCrisis;
